import styled from 'styled-components';

const StyledBlueBox = styled.div`
    background-color: #364d78;
    color: white;
`;

const StyledButtonGroup = styled.div`
    margin-top: 20px;
    button {
        width: 100%;
    }
`;

const LeftButton = styled(StyledButtonGroup)`
    grid-column: 1;
`;

const RightButton = styled(StyledButtonGroup)`
    grid-column: 3/3;
`;

export { LeftButton, RightButton, StyledBlueBox, StyledButtonGroup };
